import { ImageMediaType, ImageType } from "../types"
import { IsMobile } from "./viewport"

export const preloadImages = async (images: string[]) => {
  images.forEach((url: string) => {
    if (url) {
      const img = new Image()
      img.src = url
    }
  })
}

export const optimizedThumb = (img: ImageType): string =>
  img.optimized ? `${img.url}${img.name}-20w.webp` : img.url

// Extract the Thumb image from the provided Image (if any)
export const getThumb = (img: {
  image?: ImageType
  mobile_image?: ImageType
}): string => {
  if (img.image || img.mobile_image) {
    return IsMobile()
      ? img.mobile_image
        ? optimizedThumb(img.mobile_image) // @ts-ignore
        : optimizedThumb(img.image)
      : img.image
      ? optimizedThumb(img.image) // @ts-ignore
      : optimizedThumb(img.mobile_image)
  }
  return ""
}

// Creates a valid image element
export const toImageElement = (obj: any, keyMap: any = {}): ImageMediaType => {
  return Object.entries(obj).reduce(
    (acc: any, [key, value]: any) => {
      acc[keyMap[key] || key] = value
      return acc
    },
    {
      type: "image",
      title: "",
      loading: "eager",
      image: undefined,
      mobile_image: undefined,
      mobile_file: undefined,
    }
  )
}

// Slick breaks when his number or slides is equal or less than the param "slidesToShow"
// Therefore we duplicate the slides in case of not having enough of them:
export const minimumSlides = (slidesToShow: number, slides: any[]) =>
  slides.length >= slidesToShow
    ? slides
    : [].concat(
        ...new Array(Math.ceil(slidesToShow / slides.length)).fill(slides)
      )

export const tripadvisorRatingURL = (score: string) =>
  `https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/${parseFloat(
    score
  ).toFixed(1)}-41022-5.svg`
